import { useParams } from 'react-router-dom'
import App from './App'

function Experience() {

    const { id } = useParams()

    const validateId = (id) => {
        if (!Number.isNaN(parseInt(id)) && id.length < 10) {
            return id
        }

        return false
    }

    return (
        <App dance_id={validateId(id)} />
    )
}

export default Experience
